import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import random from 'lodash/random';
import includes from 'lodash/includes';

import FooterBanner from 'Layout/Footer/FooterBanner';

const FooterBannerContainer = ({
  ProductFooterBanner,
  pathname,
}) => {
  const excludedPaths = ['/account', '/orders', '/product-library', '/support', '/', '/review', '/reviews', '/partners/hp-omen-gaming-hub', '/welcome-new-user'];
  if (isEmpty(ProductFooterBanner)) return false;
  if (excludedPaths.includes(pathname)) return false;
  if (pathname.includes('image/preview')) return false;

  const validFooterBanners = ProductFooterBanner.filter((banner) => {
    const url = get(banner, 'url', '');
    const internalLink = includes(url, '/en');
    if (internalLink) {
      const splitUrl = url.split('/en');
      if (splitUrl.length > 1 && splitUrl[1] === pathname) return false;
    }
    return banner;
  });

  if (isEmpty(validFooterBanners)) return false;

  let footer = validFooterBanners[0];

  if (validFooterBanners.length > 1) {
    footer = validFooterBanners[random(0, (validFooterBanners.length - 1))];
  }

  if (isEmpty(footer)) return false;

  const background = footer.images.find(img => img.img_type === 'footer_background');
  const mobileBackground = footer.images.find(img => img.img_type === 'footer_mobile_background');
  const foreground = footer.images.find(img => img.img_type === 'footer_foreground');

  return (
    <FooterBanner
      url={footer.url}
      background={get(background, 'img')}
      mobileBackground={get(mobileBackground, 'img')}
      foreground={get(foreground, 'img')}
      footerBannerName={footer.name}
      footerId={footer._id}
    />
  );
};

FooterBannerContainer.propTypes = {
  ProductFooterBanner: PropTypes.arrayOf(PropTypes.object),
  pathname: PropTypes.string,
};

FooterBannerContainer.defaultProps = {
  ProductFooterBanner: [],
  pathname: '',
};

const mapStateToProps = ({
  adverts: { ProductFooterBanner },
  router: { location },
}) => ({
  ProductFooterBanner,
  pathname: location.pathname,
});

export default connect(mapStateToProps)(FooterBannerContainer);
